module.exports = __webpack_public_path__ + "static/media/pilar_kesehatan.eac92245.jpg";